import React, { createContext, useContext, useEffect, useState } from 'react'
import { dealsApi, couponsApi } from '../restaurant.api'

const DealsContext = createContext({
  loading: true,
  deals: [],
  coupons: [],
  refresh: () => {},
})

export const useDeals = () => useContext(DealsContext)

export const DealsProvider = ({ children }) => {
  const [loading, setLoading] = useState(true)
  const [deals, setDeals] = useState([])
  const [coupons, setCoupons] = useState([])

  const load = async () => {
    setLoading(true)
    const [dealsRes, couponsRes] = await Promise.all([
      dealsApi.list(),
      couponsApi.list(),
    ])
    if (dealsRes.response) setDeals(dealsRes.response.data || [])
    if (couponsRes.response) setCoupons(couponsRes.response.data || [])
    setLoading(false)
  }

  useEffect(() => {
    load()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <DealsContext.Provider value={{ loading, deals, coupons, refresh: load }}>
      {children}
    </DealsContext.Provider>
  )
}
